import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "acompanhar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "info-formulario" }, " Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas! ", -1)
const _hoisted_3 = { class: "field w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "w-full",
  for: "cpf"
}, "Código de agendamento", -1)
const _hoisted_5 = { class: "p-input-icon-right w-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi" }, null, -1)
const _hoisted_7 = { class: "field w-full" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "w-full",
  for: "cpf"
}, "E-mail do responsável", -1)
const _hoisted_9 = { class: "p-input-icon-right w-full" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi" }, null, -1)
const _hoisted_11 = { class: "flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "shadow-5" }, {
      title: _withCtx(() => [
        _createTextVNode(" Cancelamento")
      ]),
      content: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_InputText, {
              class: "",
              type: "text",
              id: "code"
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_InputText, {
              class: "w-full",
              type: "text",
              id: "code"
            })
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_Button, {
            class: "p-button-danger w-full",
            iconPos: "left",
            icon: "pi pi-times",
            label: "CANCELAR"
          })
        ])
      ]),
      _: 1
    })
  ]))
}